// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1by6h","rows":"style_rows__euy30","row":"style_row__2tm15","subtitle":"style_subtitle__1sZ6f","grid":"style_grid__3qtvZ"};